import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, filter, tap, switchMap, distinctUntilChanged, catchError } from 'rxjs/operators';
import { GenericApiFactory } from 'shared/factories/generic-api.factory';
import { GenericApiService, SpinningService } from 'shared/services';
import { ReplaySubject, BehaviorSubject, empty } from 'rxjs';
import { PagedResultModel, CodeModel } from 'shared/definition';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ParameterCodeFormComponent } from '../parameter-code-form/parameter-code-form.component';
import { parameterDataTypes } from '../../definition';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzTableComponent } from 'ng-zorro-antd/table';
/**参数数据类型字典维护*/
@Component({
  selector: 'wx-parameter-code-table',
  templateUrl: './parameter-code-table.component.html',
  styleUrls: ['./parameter-code-table.component.scss']
})
export class ParameterCodeTableComponent implements OnInit {

  queryResult$ = new ReplaySubject<PagedResultModel<CodeModel>>();

  query: any;

  form: FormGroup;

  parameterDataTypes = { ...parameterDataTypes };

  commonTrans={};

  constructor(
    private apiFactory: GenericApiFactory,
    fb: FormBuilder,
    private modalService: NzModalService,
    private spinning: SpinningService,
    private translateService:TranslateService
  ) {
    this.form = fb.group({
      keyword: [undefined]
    })
  }

  size = {
    label: "100px",
    control: "auto"
  }
  @Input()
  set apiName(_: string) {
    this.apiName$.next(_);
  }

  @Input()
  categoryName: string;

  apiName$ = new BehaviorSubject<string>(undefined);

  onPageIndexChagne(pageIndex: number) {
    var query = {
      ...this.form.value,
      ...{
        pageIndex: (pageIndex)
      }
    }
    this.spinning.startWith(this.api.query(query)).pipe(
      tap(result => {
        this.queryResult$.next(result);
      })
    ).subscribe();
  }


  @ViewChild(NzTableComponent, { static: true })
  table: NzTableComponent;
  get tableData() {
    return this.table.data as CodeModel[];
  }


  api: GenericApiService<CodeModel, any>;
  ngOnInit(): void {

    this.apiName$.pipe(
      filter(p => p != undefined),
      distinctUntilChanged(),
      tap(apiName => console.info(`apiName change triggered:${apiName}`)),
      tap(p => {

        this.api = this.apiFactory.create<CodeModel, any>(p);
      }),
      switchMap(() => this.api.query().pipe(catchError(_ => empty()))),
      tap(result => this.queryResult$.next(result))
    ).subscribe();

    this.translateService.get('Common').subscribe(trans => {
      this.commonTrans = trans;
    });

  }

  search() {
    var query = this.form.value;
    this.spinning.startWith(this.api.query(query)).pipe(
      tap(result => {
        this.queryResult$.next(result)
      })
    ).subscribe();
  }

  new() {
    this.modalService.create({
      nzTitle: `${this.commonTrans["Add"]} ${this.categoryName }`,
      nzContent: ParameterCodeFormComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        apiName: this.apiName$.value,
        model: <CodeModel>{}
      }
    }).afterClose.subscribe(() => { this.search() });

  }

  edit(item: CodeModel) {
    this.modalService.create({
      nzTitle: `${this.commonTrans["Edit"]} ${this.categoryName }`,
      nzContent: ParameterCodeFormComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        apiName: this.apiName$.value,
        model: item
      }
    }).afterClose.subscribe(() => { this.search() });
  }

  delete(item: CodeModel) {
    this.spinning.startWith(this.api.delete(item.id)).subscribe(() => { this.search() });

  }
}
